import common from "./common";
import mypage from "./mypage";
import orderAggregators from "./orderAggregators";
import about from "./about";
import terms from "./terms";
import faq from "./faq";
import specified from "./specified";
import contact from "./contact";
import notice from "./notice";

export default {
  common,
  mypage,
  orderAggregators,
  about,
  terms,
  faq,
  specified,
  contact,
  notice
};



// WEBPACK FOOTER //
// ./src/i18n/ja/index.js